import {loop, Effects} from 'redux-loop';
import * as actions from './actions';
import {fetchSourceGroup} from 'modules/sourceGroup';
import {fetchSubject} from 'modules/subject';

const initialState = {
  inited: false
}

export default (state = initialState, action) => {
  if (action.type === actions.INIT) {
    return loop(
      state
    ,
      Effects.constant(actions.inited())
    );
  };

  if (action.type === actions.INITED) {
    return loop({
      ...state,
      inited: true,
    },
      Effects.none()
    )
  };

  return loop(state, Effects.none());
}


/** WEBPACK FOOTER **
 ** ./src/app/modules/base/reducer.js
 **/